/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

export const PRINCIPAL_TYPES_TO_HUMAN_READABLE_NAMES = {
  lender: 'Lender',
  borrower: 'Borrower',
  external_api: 'External API User',
  internal_api: 'Internal API User',
  settlement_agent: 'Settlement Agent',
  title_agent: 'Title Agent',
  ops_desk_agent: 'Ops Desk Agent',
  insurance_qc_agent: 'Insurance QC Agent',
  notary: 'Notary',
  attorney: 'Attorney',
  loan_processor: 'Loan Processor',
};
